import React, { useState } from "react";
import ActionButton from "../Buttons/ActionButton";
import { FaSearch } from "react-icons/fa";
import { useLanguage } from "../LangTranslation/LanguageContext";
import { useSession } from "../../authentications/SessionContext";
import { primaryColor } from "../../utilities/colors";

function TableToolbar({
  selectedRows,
  setSelectedRows,
  setSearchQuery,
  handleEditList,
  handleDelete,
  showExportBtn = false,
  handleExport,
}) {
  const { language, translations } = useLanguage();
  const t = translations[language];
  const { sessionInfo } = useSession();

  const { isVTEX ,is_ion_admin } = sessionInfo;
  const [searchWithType, setSearchWithType] = useState("");

  const handleChangeSearch = (e) => {
    const { value } = e.target;
    if (value === "") {
      setSearchQuery(value);
    }
    setSearchWithType(e.target.value);
  };
  const handleSubmitSearch = (e) => {
    e.preventDefault();
    setSearchQuery(searchWithType);
  };

  return selectedRows?.length === 0 ? (
    <form className="searchdiv" onSubmit={handleSubmitSearch}>
      <div className="search-container">
        <div className="SearchIcon" role="button">
          <FaSearch />
        </div>
        <input
          type="text"
          placeholder={t["Search"]}
          value={searchWithType}
          onChange={handleChangeSearch} 
        />
      </div>
    </form>
  ) : (
    <div
      selectedMenu
      style={{
        height: "64px",
        display: "flex",
        alignItems: "center",
      }}
    >
      {selectedRows?.length === 1 && (
        <ActionButton
          onClick={() => handleEditList(selectedRows[0])}
          name="Edit"
          isVTEX={isVTEX}
        />
      )}
      <ActionButton onClick={handleDelete} name="Delete" isVTEX={isVTEX} />
      <ActionButton
        onClick={() => setSelectedRows([])}
        name="Clear"
        isVTEX={isVTEX}
      />
      {showExportBtn &&  !is_ion_admin &&(
        <button
          className="btn btn-sm"
          onClick={() => handleExport(selectedRows)}
          style={{
            background: primaryColor.primary,
            color: "#fff",
            borderRadius: "10px",
            minWidth: "80px",
            height: "30px",
            marginRight: "20px",
          }}
        >
          <i className="bi bi-file-earmark-arrow-down-fill"></i>{" "}
          {t["Export Products"]}
        </button>
      )}
    </div>
  );
}

export default TableToolbar;
